import { BrowserModule, Title } from '@angular/platform-browser';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { PlaceholderModule } from './placeholder/placeholder.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesModule } from './pages/pages.module';
import { PrivacyNoticeModule } from './privacy-notice/privacy-notice.module';
import { SharedModule } from './shared/shared.module';
import 'simplebar';
import { DatePipe } from '@angular/common';
import { LandingModule } from './landing/landing.module';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ToastrModule } from 'ngx-toastr';
import { provideHttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

 @NgModule({

    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        LandingModule,
        PagesModule,
        PrivacyNoticeModule,
        CoreModule,
        PlaceholderModule,
        BrowserAnimationsModule,
        SharedModule,
        ToastrModule.forRoot(),
        NgCircleProgressModule.forRoot(),
        NgbModule
    ],
     exports: [
        BrowserModule,
        AppRoutingModule,
        LandingModule,
        PagesModule,
        PrivacyNoticeModule,
        CoreModule,
        PlaceholderModule,
        BrowserAnimationsModule,
        SharedModule
    ],
    providers: [
        Title,
        TitleCasePipe,
        DatePipe,
        provideHttpClient()
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }